var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AlertAggregationType } from '@logz-pkg/enums';
import { Expose, Transform, Type } from 'class-transformer';
import { AccountModel } from '../account/account';
import { alertModelManipulator } from './alert.manipulator';
class AlertAggregation {
    type = AlertAggregationType.NumberOfLogs;
    field = null;
    value = null;
}
__decorate([
    Expose({ name: 'aggregationType' }),
    __metadata("design:type", String)
], AlertAggregation.prototype, "type", void 0);
__decorate([
    Expose({ name: 'fieldToAggregateOn' }),
    Transform((value) => value && value.name, { toPlainOnly: true }),
    __metadata("design:type", Object)
], AlertAggregation.prototype, "field", void 0);
__decorate([
    Expose({ name: 'valueToAggregateOn' }),
    Transform((value) => value, { toPlainOnly: true }),
    __metadata("design:type", Object)
], AlertAggregation.prototype, "value", void 0);
export class AlertQueryModel {
    query = '*';
    shouldQueryOnAllAccounts = false;
    groupBy = [];
    aggregation = new AlertAggregation();
    accountsToQueryOn = [];
    // We're sending elastic DSL as the filters
    // No type is added due to: https://github.com/typestack/class-transformer/issues/308
    filters = [];
}
__decorate([
    Transform((value) => value.map(field => field.name), { toPlainOnly: true }),
    Transform((value) => value.map(name => ({ name })), { toClassOnly: true }),
    __metadata("design:type", Array)
], AlertQueryModel.prototype, "groupBy", void 0);
__decorate([
    Type(() => AlertAggregation),
    __metadata("design:type", AlertAggregation)
], AlertQueryModel.prototype, "aggregation", void 0);
__decorate([
    Type(() => AccountModel),
    Expose({ name: 'accountIdsToQueryOn' }),
    Transform((accounts) => accounts.map(account => account.id), { toPlainOnly: true }),
    __metadata("design:type", Array)
], AlertQueryModel.prototype, "accountsToQueryOn", void 0);
__decorate([
    Transform((_, alertQuery) => alertModelManipulator.convertFiltersToElastic(alertQuery), { toPlainOnly: true }),
    Transform((value) => alertModelManipulator.convertElasticToFilters(value), { toClassOnly: true }),
    __metadata("design:type", Array)
], AlertQueryModel.prototype, "filters", void 0);
//# sourceMappingURL=alert-query.js.map